export default "__VITE_ASSET__QPf_hzXr__"